export default __webpack_public_path__ + "static/media/uploader-abbottLibre-2.1a13ac0d.png";